/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseRubricItem } from './BaseRubricItem';
const RubricItemInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', /* #__PURE__ */ codecOptional(codecNumber)],
]), BaseRubricItem);
export class RubricItemInputAsJSON extends BaseRubricItem {
    static decode(input) {
        return RubricItemInputAsJSONParser.decode(input).map(res => new RubricItemInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return RubricItemInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricItemInputAsJSONParser.encode(data);
    }
    static schema() {
        return RubricItemInputAsJSONParser.schema();
    }
}
